<template>
  <v-navigation-drawer
    v-if="items"
    app
    class="be-drawer-menu"
    :mini-variant="
      closeDrawer && $vuetify.breakpoint.mdAndUp && hover ? false : closeDrawer
    "
    permanent
    stateless
    v-model="drawer"
    :width="$vuetify.breakpoint.mdAndUp ? undefined : '256px'"
  >
    <v-list
      dense
      nav
    >
      <v-list-item
        link
        @click.stop="closeDrawer = !closeDrawer"
      >
        <v-list-item-icon>
          <v-icon class="white--text">mdi-menu</v-icon>
        </v-list-item-icon>
        <v-list-item-content> </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list
      dense
      nav
    >
      <v-menu
          offset-x
          :close-on-content-click="false"
          v-model="showAccessibilityOptions"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              link
              v-bind="attrs"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon
                  class="white--text"
                  size="22"
                  >fa-universal-access</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">
                  {{ $t("menu.labels.accessibility") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <AccessibilityOptions @close="showAccessibilityOptions = false" />
        </v-menu>
      <template v-for="item in items">
        <v-list-group
          :key="item.title"
          @click="item.click"
          :to="{ name: item.name, params: item.params ? item.params : {} }"
          v-if="
            item.sub_items &&
            hasPermission(item.permissions) &&
            (item.modules ? hasModules(item.modules) : true)
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon
              class="white--text"
              :class="item.icon.includes('fa') ? '' : 'ms-n1'"
              :size="item.icon.includes('fa') ? 20 : 24"
              >{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title class="white--text">{{
              item.title
            }}</v-list-item-title>
          </template>
          <template v-for="sub in item.sub_items">
            <v-list-item
              v-if="
                sub.permissions && sub.permissions.length > 0
                  ? hasPermission(sub.permissions)
                  : true
              "
              :key="sub.title"
              :to="{ name: sub.name, params: item.params ? item.params : {} }"
              link
              @click="sub.click"
            >
              <v-list-item-icon>
                <v-icon
                class="white--text"
                :class="sub.icon.includes('fa') ? '' : 'ms-n1'"
                :size="sub.icon.includes('fa') ? 20 : 24"
                >{{ sub.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text"
                  >{{ sub.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>

        <v-list-item
          @click="item.click"
          :key="`list_${item.title}`"
          :to="{
            name: item.name,
            params: item.params ? item.params : {},
            query: item.query ? item.query : {},
          }"
          link
          v-else-if="
            (item.permissions && item.permissions.length > 0
              ? hasPermission(item.permissions)
              : true) &&
            (item.modules ? hasModules(item.modules) : true) == true
          "
        >
          <v-list-item-icon>
            <v-icon
            class="white--text"
            :class="item.icon.includes('fa') ? '' : 'ms-n1'"
            :size="item.icon.includes('fa') ? 20 : 24"
            >{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text"
              >{{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <div v-if="!closeDrawer" class="d-flex align-center px-4 mb-2">
      <v-btn color="#17a2b8" block small class="white--text font-weight-bold elevation-0" @click="emitTour">
        {{ $t('menu.tour') }}
        <v-icon class="ml-2" small style="color: yellow !important;">fas fa-stars</v-icon>
      </v-btn>
    </div>
      <v-btn v-else :title="$t('menu.tour')" color="transparent" small class="font-weight-bold elevation-0" @click="emitTour">
        <v-icon color="white">fas fa-stars</v-icon>
      </v-btn>
  </v-navigation-drawer>
</template>

<script>
import appApi from "@/plugins/api/api";
import libraryModule from "@/modules/library/navbarMenu/index";
import AccessibilityOptions from "./AccessibilityOptions";
import { EventBus } from '@/eventBus';

export default {
  components: {
    AccessibilityOptions,
  },
  data() {
    return {
      showAccessibilityOptions: false,
      items: null,
      drawer: true,
      closeDrawer: !this.$vuetify.breakpoint.mdAndUp,
      types: [],
      iconTypes: {
        Online: "mdi-wifi",
        "0800": "mdi-phone",
        Email: "mdi-email",
        Presencial: "mdi-account",
      },
      typesPermissions: {
        Online: ["compliance", "requester", "requests_manager"],
        "0800": ["compliance", "requester", "requests_manager"],
        Email: ["compliance", "requester", "requests_manager"],
        Presencial: ["compliance", "requester", "requests_manager"],
      },
    };
  },
  created() {
    this.makeMenu();
  },

  methods: {
    makeMenu() {
      const menu = [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          name: "Dashboard",
          permissions: ["compliance", "request_reviewer", "requests_manager"],
        },
        {
          title: "Chamados",
          icon: "mdi-comment-account",
          name: "Requests",
          permissions: [
            "compliance",
            "requester",
            "request_reviewer",
            "requests_manager",
          ],
          query: { status: ["open", "under_analysis"] },
        },
        {
          title: "Responsáveis",
          icon: "mdi-shield-account",
          name: "AssociateResponsibleList",
          permissions: ["compliance", "requests_manager"],
        },
        {
          title: "Treinamentos",
          icon: "fa-university",
          name: "CourseIndex",
          permissions: [],
          modules: ["course_requests"],
          query: {
            folderId: "root",
          },
        },
        {
          title: "Minhas Atividades",
          icon: "mdi-playlist-check",
          name: "Activities",
          permissions: [
            "compliance",
            "requester",
            "request_activity_support",
            "requests_manager",
          ],
        },
        libraryModule,
        {
          title: "Configurações",
          icon: "mdi-cogs",
          name: "RequestsConfigurations",
          permissions: ["compliance", "requests_manager", "information_technology"],
          sub_items: [
            {
              title: "Formulário",
              icon: "fa-rectangle-list",
              name: "RequestsConfigurations",
              permissions: ["compliance", "requests_manager"],
            },
            {
              title: "E-mails",
              icon: "fa-envelope",
              name: "Configurations",
              permissions: ["compliance", "requests_manager", "information_technology"],
            },
            {
              title: "Logins",
              icon: "fa-users-cog",
              name: "CompanyLoginsList",
              permissions: ["information_technology"],
            },
            
          ]
        },
        {
          title: "Cadastros",
          icon: "mdi-view-list",
          permissions: ["compliance", "requests_manager", "information_technology"],
          sub_items: [
            {
              title: "Tipos",
              icon: "mdi-sitemap",
              name: "Types",
              permissions: ["compliance", "requests_manager"],
            },
            {
              title: "Unidades",
              icon: "mdi-office-building-marker",
              name: "LocationsList",
              permissions: ["compliance", "requests_manager"],
            },
            {
              title: "Subcategorias",
              icon: "mdi-shape-outline",
              name: "Subcategory",
              permissions: ["compliance", "requests_manager"],
            },
            {
              title: "Substatus",
              icon: "mdi-google-maps",
              name: "Substatus",
              permissions: ["compliance", "requests_manager"],
            },
            {
              title: "Mensagens Personalizadas",
              icon: "fa-comment-alt-smile",
              name: "PresetMessages",
              permissions: ["compliance", "requests_manager"],
            },
            {
              title: "Usuários",
              icon: "mdi-account-group",
              name: "UserIndex",
              permissions: [
                "compliance",
                "information_technology",
                "requests_manager",
              ],
            },
            {
              title: "Departamentos",
              icon: "fa-sitemap",
              name: "DepartmentIndex",
              permissions: ["compliance", "requests_manager"],
            },
          ],
        },
        {
          title: "Adicionar",
          icon: "mdi-comment-plus",
          sub_items: this.types,
          permissions: ["compliance", "requester", "requests_manager"],
        },

        {
          title: "Grupos",
          icon: "mdi-layers-triple",
          name: "GroupIndex",
          permissions: ["compliance", "training_manager_requests", "requests_manager"],
        },
        {
          title: "Auditoria",
          icon: "mdi-view-list",
          name: "Audit",
          permissions: ["auditer"],
        },
        {
          title: "Ajuda",
          icon: "mdi-lifebuoy",
          name: "ManualView",
          permissions: [],
        },
      ];
      this.typesRequest();
      this.items = menu;
    },
    typesRequest() {
      appApi
        .getTypeRequestOrigin()
        .then((res) => {
          res.data.data.forEach((element) => {
            this.types.push({
              title: element.name,
              icon: this.iconTypes[element.name],
              permissions: this.typesPermissions[element.name],
              name: "",
              click: () => {
                window
                  .open(
                    "/canal-etica/canal-denuncias?origin=" + element.value,
                    "_blank",
                  )
                  .focus();
              },
            });
          });
        })
        .catch((err) => {});
    },
    hasPermission(permission) {
      if (permission) {
        return this.$store.getters.hasUserProfiles(permission);
      }
      return true;
    },
    hasModules(modules) {
      for (let i = 0; i < modules.length; i++) {
        if (this.$store.state.user.modules.indexOf(modules[i]) != -1) {
          return true;
        }
      }
      return false;
    },
   
    emitTour() {
      if (EventBus) {
      EventBus.$emit('tour', "wmpair9wslhc");
    }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/defaults.scss";

.be-drawer-menu {
  background-color: var(--v-background-high-base) !important;
}

.be-drawer-menu ::v-deep .v-icon {
  color: #fff !important;
}
.be-drawer-menu ::v-deep .v-list-group__items {
  margin-left: 10px;
  border-left: 1px dotted #fff;
  font-weight: bold !important
}

.be-drawer-menu ::v-deep .v-list-item__title {
  font-weight: bold !important;
}

* {
  ::-webkit-scrollbar {
    background-color: var(--v-background-high-base);
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #ffffff22;
  }
}

.high-contrast-settings {
  * {
    ::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background-color: #ffffffAA;
    }
  }
}
</style>
